<template id="geo-selector">
  <div>
    <div class="columns">
      <div class="column">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Longitude:</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input
                        class="input"
                        v-model="geo.lng"
                        type="number"
                        step="any"
                        placeholder="151.1996091">
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Latitude:</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  v-model="geo.lat"
                  type="number"
                  step="any"
                  placeholder="-33.8686494">
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal" v-if="showZoom">
          <div class="field-label is-normal">
            <label class="label">Zoom:</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" v-model="geo.zoom" type="number" placeholder="0">
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label"></label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <button @click.prevent="locateMe" class="button is-info is-outlined" style="width: 250px;">Locate me
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <GmapMap
          :center="{lat:parseFloat(geo.lat), lng:parseFloat(geo.lng)}"
          :zoom="getZoom(geo.zoom)"
          map-type-id="terrain"
          style="height: 300px"
          @zoom_changed="zoomChanged"
        >
          <GmapMarker
            :position="{lat: parseFloat(geo.lat), lng: parseFloat(geo.lng)}"
            :clickable="true"
            :draggable="true"
            @dragend="onMarkerDragend"
          />
        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GeoSelector',
    props: {
      disableAutoLocate: false,
      showZoom: true,
    },
    data() {
      return {
        geo: {
          lat: 0,
          lng: 0,
          zoom: 0
        },
        defaultZoom: 14,
      }
    },
    mounted() {
      if (this.disableAutoLocate + '' !== 'true') {
        this.locateMe()
      }
    },
    watch: {
      geo: {
        handler: function () {
          const emitted = {lat: this.geo.lat, lng: this.geo.lng, zoom: this.geo.zoom}
          this.$emit('updated', emitted)
        },
        deep: true,
      }
    },
    methods: {
      zoomChanged(zoom) {
        this.geo.zoom = zoom
      },
      locateMe() {
        console.log('LocateMe has been called!')
        navigator.geolocation.getCurrentPosition((position) => {
          this.setGeo({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            zoom: this.defaultZoom,
          })
        })
      },
      setGeo(geo) {
        if (geo && !geo.zoom) {
          geo.zoom = this.defaultZoom
        }
        this.geo = geo
      },
      setLatLng(lat, lng) {
        this.setGeo({
          lat: lat,
          lng: lng,
          zoom: this.geo.zoom > 0 ? this.geo.zoom : this.defaultZoom,
        })
      },
      getZoom(zoom) {
        if (zoom) {
          return parseInt(zoom)
        }
        return 0
      },
      onMarkerDragend(location) {
        this.geo.lat = location.latLng.lat()
        this.geo.lng = location.latLng.lng()
      },
    }
  }
</script>

<style scoped>
  .field-label {
    flex-grow: 0;
  }

  .field-label label {
    width: 180px !important;
  }
</style>
